if (!customElements.get('custom-certificates')) {
  customElements.define(
    'custom-certificates',
    class CustomCertificates extends HTMLElement {
      connectedCallback() {
        this.container = this.querySelector('.custom-certificates__marquee-container');
        this.tracks = Array.from(this.querySelectorAll('.custom-certificates__track'));
        this.resumeTimeout = null;
        this.isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

        if (!this.container || !this.tracks.length || !this.isTouchDevice) {
          return;
        }

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);

        this.container.addEventListener('pointerdown', this.onPointerDown, { passive: true });
        this.container.addEventListener('pointerup', this.onPointerUp, { passive: true });
        this.container.addEventListener('pointercancel', this.onPointerUp, { passive: true });
      }

      disconnectedCallback() {
        window.clearTimeout(this.resumeTimeout);

        this.container?.removeEventListener('pointerdown', this.onPointerDown);
        this.container?.removeEventListener('pointerup', this.onPointerUp);
        this.container?.removeEventListener('pointercancel', this.onPointerUp);
      }

      setPaused(isPaused) {
        this.tracks.forEach((track) => {
          track.classList.toggle('is-paused', isPaused);
        });
      }

      onPointerDown(event) {
        if (event.pointerType === 'mouse') {
          return;
        }

        window.clearTimeout(this.resumeTimeout);
        this.setPaused(true);
      }

      onPointerUp() {
        window.clearTimeout(this.resumeTimeout);
        this.resumeTimeout = window.setTimeout(() => {
          this.setPaused(false);
        }, 400);
      }
    }
  );
}
